/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TraineeUserProfileDTO
 */
export interface TraineeUserProfileDTO {
    /**
     * 
     * @type {string}
     * @memberof TraineeUserProfileDTO
     */
    username: string;
    /**
     * 
     * @type {number}
     * @memberof TraineeUserProfileDTO
     */
    accountType: TraineeUserProfileDTOAccountTypeEnum;
}


/**
 * @export
 */
export const TraineeUserProfileDTOAccountTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type TraineeUserProfileDTOAccountTypeEnum = typeof TraineeUserProfileDTOAccountTypeEnum[keyof typeof TraineeUserProfileDTOAccountTypeEnum];


/**
 * Check if a given object implements the TraineeUserProfileDTO interface.
 */
export function instanceOfTraineeUserProfileDTO(value: object): value is TraineeUserProfileDTO {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('accountType' in value) || value['accountType'] === undefined) return false;
    return true;
}

export function TraineeUserProfileDTOFromJSON(json: any): TraineeUserProfileDTO {
    return TraineeUserProfileDTOFromJSONTyped(json, false);
}

export function TraineeUserProfileDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TraineeUserProfileDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'accountType': json['accountType'],
    };
}

export function TraineeUserProfileDTOToJSON(json: any): TraineeUserProfileDTO {
    return TraineeUserProfileDTOToJSONTyped(json, false);
}

export function TraineeUserProfileDTOToJSONTyped(value?: TraineeUserProfileDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'accountType': value['accountType'],
    };
}

